import { ICouponApplied } from 'types/coupon';
import { getCouponScope } from 'services/coupon/type';
import { couponScopeConst } from 'config/coupon';
import {
    getPlatformCoupon,
    getShopCoupon,
    recheckPlatformCoupon
} from 'services/coupon/get-coupon-list';
import { computeCouponDiscount } from 'services/coupon/compute-coupon-discount';
import { classifyCouponByShop } from 'services/coupon/classify-coupon-by-shop';
import { CouponGoodsItem } from 'types/cart';

export const changeCouponStatus = (
    list: ICouponApplied[],
    coupon: ICouponApplied,
    amount: number,
    discount: number
) => {
    const couponScope = getCouponScope(coupon);
    if (couponScope === couponScopeConst.shop) {
        if (!coupon.selected) {
            let platform = recheckPlatformCoupon(list, amount - discount);
            if (amount - discount - computeCouponDiscount(coupon, amount) <= 0) {
                // 如果已有的优惠已经减去之后小于 0， 则不实用平行优惠
                platform = recheckPlatformCoupon(
                    list,
                    amount - discount - computeCouponDiscount(coupon, amount)
                );
            }
            platform.forEach((item) => {
                if (item.selected) {
                    changeCouponStatus(list, item, amount, discount);
                }
            });
        } else {
            recheckPlatformCoupon(list, amount - discount);
        }
    }
    if (coupon.selected) {
        list.forEach((item) => {
            if (
                (couponScope === couponScopeConst.platform &&
                    couponScope === getCouponScope(item)) ||
                (couponScope === couponScopeConst.shop && coupon.shopId === item.shopId)
            ) {
                item.selected = false;
                item.disable = false;
                const index = item.explain.indexOf('与已选券不能共享');
                if (item.explain && index > -1) {
                    item.explain.splice(index, 1);
                }
            }
        });
    } else {
        list.forEach((item) => {
            if (
                (couponScope === couponScopeConst.platform &&
                    couponScope === getCouponScope(item)) ||
                (couponScope === couponScopeConst.shop && coupon.shopId === item.shopId)
            ) {
                if (item.id === coupon.id) {
                    item.selected = true;
                } else {
                    if (item.explain) {
                        item.explain.push('与已选券不能共享');
                    } else {
                        item.explain = ['与已选券不能共享'];
                    }
                    item.disable = true;
                }
            }
        });
    }

    return list;
};

export const changeMultiShopStatus = (
    list: ICouponApplied[],
    maxCoupon: Record<string, ICouponApplied | undefined>,
    goodsList: CouponGoodsItem[],
    needReason: boolean = true
) => {
    const resultAvailable = classifyCouponByShop(list);

    Object.keys(maxCoupon).forEach((shopId) => {
        if (shopId !== 'platform') {
            if (maxCoupon[shopId]) {
                const amount = goodsList
                    .filter((item) => item.shopId === shopId)
                    .reduce(
                        (total, next) =>
                            total + next.SCReducer > 0 ? next.price * next.amount : 0,
                        0
                    );
                const discount = goodsList
                    .filter((item) => item.shopId === shopId)
                    .reduce(
                        (total, next) => (total + next.SCReducer > 0 ? next.FDReducer || 0 : 0),
                        0
                    );
                if (needReason) {
                    getShopCoupon(
                        resultAvailable[shopId],
                        goodsList.filter((item) => item.shopId === shopId)
                    );
                }
                changeCouponStatus(
                    resultAvailable[shopId],
                    maxCoupon[shopId] as ICouponApplied,
                    amount,
                    discount
                );
            }
        }
    });

    if (maxCoupon.platform) {
        needReason && getPlatformCoupon(resultAvailable.platform, goodsList);
        changeCouponStatus(resultAvailable.platform, maxCoupon.platform, 0, 0);
    }
};
